/**
 * Browser → API origin SSOT (tenant/platform SPA).
 *
 * Canonical staging/production path (option A): same-origin `/api/*` via Vercel rewrite
 * (`vercel.staging.json` / `vercel.production.json` per project — see config/vercel/README.md).
 * Do not set VITE_API_BASE_URL on Vercel when using option A.
 *
 * Local dev: set VITE_API_BASE_URL or VITE_BACKEND_URL to `http://localhost:3001`.
 * Cross-origin fallback (option B): set VITE_API_BASE_URL to full API host at build time.
 */

const LOCAL_DEV_FALLBACK = 'http://localhost:3001';

function normalizeExplicitApiOrigin(raw: string): string {
  return raw
    .replace(/\/api\/site\/studio\/model\/?$/, '')
    .replace(/\/api\/?$/, '')
    .replace(/\/$/, '');
}

function readExplicitApiOrigin(): string | undefined {
  const raw = import.meta.env.VITE_BACKEND_URL?.trim() || import.meta.env.VITE_API_BASE_URL?.trim();
  return raw ? normalizeExplicitApiOrigin(raw) : undefined;
}

/** API host for `${origin}/api/...` fetch calls (no trailing slash). */
export function resolveApiOrigin(): string {
  const explicit = readExplicitApiOrigin();
  if (explicit) return explicit;

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return LOCAL_DEV_FALLBACK;
}
